import { useState } from 'react';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-nv-black py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 pb-12 md:pb-16 border-b border-white/10">
            <div className="lg:w-[40%]">
              <h3 className="text-white text-2xl md:text-3xl font-semibold mb-4">
                Nova Vertex LTD
              </h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Building technology and marketing strategies that help businesses grow
                — from concept to launch and beyond.
              </p>
            </div>

            <div className="lg:w-[25%]">
              <h4 className="text-white/50 text-xs uppercase tracking-wider mb-5">
                Navigation
              </h4>
              <div className="flex flex-col gap-3">
                <a href="#about-us" onClick={(e) => handleNavClick(e, '#about-us')} className="text-white text-sm hover:underline cursor-pointer">
                  About Us
                </a>
                <a href="#our-services" onClick={(e) => handleNavClick(e, '#our-services')} className="text-white text-sm hover:underline cursor-pointer">
                  Our Services
                </a>
                <a href="#our-products" onClick={(e) => handleNavClick(e, '#our-products')} className="text-white text-sm hover:underline cursor-pointer">
                  Our Products
                </a>
                <a href="#contact-us" onClick={(e) => handleNavClick(e, '#contact-us')} className="text-white text-sm hover:underline cursor-pointer">
                  Contact Us
                </a>
              </div>
            </div>

            <div className="lg:w-[35%]">
              <h4 className="text-white/50 text-xs uppercase tracking-wider mb-5">
                Contacts
              </h4>
              <div className="flex flex-col gap-2 mb-8">
                <p className="text-white text-sm">+44 7520 663474</p>
                <p className="text-white text-sm">support@novavertextech.com</p>
              </div>
              <h4 className="text-white/50 text-xs uppercase tracking-wider mb-3">
                Address
              </h4>
              <p className="text-white text-sm leading-relaxed">
                International House<br />
                66 Lavender Hill<br />
                London<br />
                SW11 5RQ<br />
                United Kingdom
              </p>
            </div>
          </div>

          <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-6">
            <p className="text-white/40 text-xs text-center sm:text-left">
              &copy; 2026 Nova Vertex LTD. All rights reserved.
            </p>

            <div className="flex items-center gap-4">
              <a href="/terms" className="text-white/50 text-xs hover:text-white transition-colors underline">
                Terms of Use
              </a>
              <a href="/privacy" className="text-white/50 text-xs hover:text-white transition-colors underline">
                Privacy Policy
              </a>
              <a href="/refund" className="text-white/50 text-xs hover:text-white transition-colors underline">
                Refund Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
